// DeleteMediaBlockedModal — ISP-9999 medialib-multiselect-partial-delete
// (Gordon-reported). Step 2 of the two-step bulk-delete flow: shown ONLY when
// a multi-select delete had at least one locked file. By the time this modal
// opens, the BE has already deleted every non-conflicting file in the batch
// (see index.jsx's deleteMutation) — this is purely informational, listing
// the files that were skipped and why, so the user isn't left guessing which
// of their N selected files actually went away.
import React from "react";
import PropTypes from "prop-types";
import * as S from "./MediaLibrary.styled";
import { IconClose } from "./icons";

export default function DeleteMediaBlockedModal({ open = true, items = [], onClose }) {
  if (!open || items.length === 0) return null;
  const count = items.length;

  return (
    <S.Backdrop
      role="dialog"
      aria-modal="true"
      aria-label="Some files could not be deleted"
      data-testid="delete-blocked-modal"
      onClick={(e) => e.target === e.currentTarget && onClose && onClose()}
    >
      <S.Modal w={520}>
        <S.ModalHead>
          <div>
            <div className="t">
              {count > 1 ? `${count} files couldn't be deleted` : "1 file couldn't be deleted"}
            </div>
            <div className="sub">Every other selected file was deleted.</div>
          </div>
          <button type="button" className="x" aria-label="Close" onClick={onClose}>
            <IconClose size={20} />
          </button>
        </S.ModalHead>
        <S.ModalBody>
          <ul style={{ margin: 0, padding: 0, listStyle: "none", display: "flex", flexDirection: "column", gap: 10 }}>
            {items.map((i) => (
              <li key={i.path} data-testid="delete-blocked-item" style={{ fontSize: 14, color: "#123051" }}>
                <div style={{ fontWeight: 700, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                  {i.name || i.path}
                </div>
                <div style={{ color: "#565556", marginTop: 2 }}>{i.reason}</div>
              </li>
            ))}
          </ul>
        </S.ModalBody>
        <S.ModalFoot>
          <S.PrimaryButton onClick={onClose}>Got it</S.PrimaryButton>
        </S.ModalFoot>
      </S.Modal>
    </S.Backdrop>
  );
}

DeleteMediaBlockedModal.propTypes = {
  open: PropTypes.bool,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string.isRequired,
      name: PropTypes.string,
      reason: PropTypes.string,
    })
  ),
  onClose: PropTypes.func,
};
